<template>
  <v-form>
    <SelectRichItems
      v-model="formData.services"
      :field-key="fieldKey('services')"
      :label="$t('Service.Service')"
      get-items-api="available-services/"
      item-text="id"
      item-text-translate-key="Service.Brand"
      item-value="id"
      icon-file-key="icon_file"
      design-label
    />
    <v-row
      class="justify-end flex-wrap"
      style="margin-top: -30px;"
    >
      <ActionButton
        :label="$t('UserList.ChangeToSelectServices')"
        class="mt-3 ma-2 pa-2"
        @click="submit('change_users_to_services')"
      />
      <ActionButton
        :label="$t('UserList.AddToSelectServices')"
        class="mt-3 ma-2 pa-2"
        @click="submit('add_users_to_services')"
      />
      <ActionButton
        :label="$t('UserList.RemoveToSelectServices')"
        class="mt-3 ma-2 pa-2"
        @click="submit('remove_users_to_services')"
      />
    </v-row>
  </v-form>
</template>

<script>
  import FormMixin from './FormMixin'
  import ActionButton from '@/components/parts/button/ActionButton'
  import SelectRichItems from '@/components/parts/inputs/SelectRichItems'

  export default {
    components: {
      SelectRichItems,
      ActionButton
    },
    mixins: [FormMixin],
    props: {
      selectUsers: {
        type: Array,
        default () {
          return []
        }
      }
    },
    emits: ['reload'],
    data: () => ({
      formData: {
        services: []
      }
    }),
    methods: {
      submit (action) {
        let formData = {
          services: this.convertList(this.formData.services),
          users: this.convertList(this.selectUsers)
        }
        this.$http.post(`/available-services/${action}/`, formData).then(
          (res) => {
            this.$emit('reload')
          })
      },
      convertList (target) {
        let ret = []
        for (let k of Object.keys(target)) {
          ret.push(target[k])
        }
        return ret
      }
    }
  }
</script>
